import { FileBasic } from '@commenda/types/src/file/types';
import { fetcher } from '@commenda/utils';

export interface TUpdateFileFolderProps {
  corporationId: number;
  files: FileBasic[];
}

export default async function updateFileFolder({
  fileFolderId,
  body,
  nextAuthToken,
}: {
  fileFolderId: string;
  body: TUpdateFileFolderProps;
  nextAuthToken: string;
}): Promise<boolean> {
  const res = await fetcher(
    `fileFolder/${fileFolderId}`,
    {
      method: 'POST',
      body,
    },
    nextAuthToken
  );
  if (!res.ok) return false;

  return true;
}
